
import '../components'
import '../mock'
import _i18n from '../i18n'
import getRoutes from '../router/index'

export const i18n = _i18n
export const router = getRoutes(require.context('../pages', true, /\.vue$/))